import {
  IDynamicReportGeneral,
  DynamicReportType,
  ICustomColumn,
  IParameter,
  IDynamicReportConfig,
  OPERATOR,
  IOption,
} from './dynamic-report-general.interface';
import { BaseModel, Default } from '@red/data-access';
import { ExecljsParameterValueType, IExceljsParameterControlType } from '@shared/components/exceljs-viewer';
import { UpdatedByModel } from '@shared/data-access/models';
import { Expose, Transform, Type } from 'class-transformer';

export class DynamicReportGeneralModel extends BaseModel implements IDynamicReportGeneral {
  @Expose()
  id!: number;

  @Expose()
  name!: string;

  @Expose()
  createdAt!: Date;

  @Expose()
  createdBy!: UpdatedByModel;

  @Expose()
  updatedBy!: UpdatedByModel;

  @Expose()
  updatedAt!: Date;

  @Expose()
  description!: string;

  @Expose()
  reportType!: DynamicReportType;

  @Expose()
  isActive?: boolean;

  @Expose()
  isPublic?: boolean;

  @Expose()
  @Type(() => CustomColumnModel)
  customColumns?: CustomColumnModel[];

  @Expose()
  @Type(() => ParameterModel)
  parameters?: ParameterModel[];

  @Expose()
  config?: IDynamicReportConfig;
}
export class CustomColumnModel extends BaseModel implements ICustomColumn {
  @Expose()
  displayName!: string;

  @Expose()
  alias!: string;

  @Expose()
  column!: string;

  @Expose()
  @Transform(({ value }) => value ? value : undefined)
  columnType!: string;

  @Expose()
  fieldType!: string;

  @Expose()
  @Default(20)
  width!: number;

  @Expose()
  sequence!: number;

  @Expose()
  isVisible!: boolean;

  @Expose()
  isFilterable!: boolean;

  @Expose()
  isSortable!: boolean;

  @Expose()
  isRequired!: boolean;

}

export class ParameterModel extends BaseModel implements IParameter {
  @Expose()
  displayName!: string;

  @Expose()
  alias!: string;

  @Expose()
  column!: string;

  @Expose()
  @Transform(({ value }) => value ? value : undefined)
  columnType!: string;

  @Expose()
  type!: IExceljsParameterControlType;

  @Expose()
  valueType!: ExecljsParameterValueType;

  @Expose()
  @Transform(({ obj, value }) => {
    if (Array.isArray(value) && obj.options?.length > 0) {
      if (obj.type === 'selection') {
        const _value = value?.[0] === 'true' ? true : (value?.[0] === 'false' ? false : value?.[0]);
        return obj.options.find((e: any) => e?.value === _value);
      } else if (obj.type === 'multi-selection') {
        return obj?.options?.filter((e: any) => value?.includes(e?.value))
      }
    }
    return value;
  })
  value!: any;

  @Expose()
  @Transform(({ obj, value }) => value ? value : { alias: obj?.alias, column: obj?.column, displayName: obj?.displayName })
  param!: any;

  @Expose()
  default?: any;

  @Expose()
  options?: IOption[];

  @Expose()
  isVisible!: boolean;

  @Expose()
  templateRef?: string;

  @Expose()
  isEditable?: boolean;

  @Expose()
  operator?: OPERATOR;

  @Expose()
  operators?: OPERATOR[];
}